import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { z } from 'zod';

import { ModerationClient } from '@/components/admin/moderation-client';
import { PageHeader } from '@/components/dashboard/page-header';

export const Route = createFileRoute('/_admin/admin/moderation')({
  validateSearch: z.object({ reportId: z.string().optional() }),
  component: ModerationPage,
});

function ModerationPage(): React.ReactElement {
  const { reportId } = Route.useSearch();
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-6">
      <PageHeader
        title="Modération"
        subtitle="Signalements de messages en attente de traitement."
      />
      <ModerationClient focusReportId={reportId ?? null} />
    </div>
  );
}
